import { Popover, MenuList, MenuItem, ListItemText, Divider } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';

interface SfFunnelMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onClick: (action: 'remove' | 'delete') => void;
}

export const SfFunnelMenu = ({ anchorEl, onClose, onClick }: SfFunnelMenuProps) => {
  return (
    <Popover
      open
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: -7,
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: -8,
      }}
    >
      <MenuList>
        <MenuItem onClick={() => onClick('remove')}>
          <ListItemText>Remove from Canvas</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => onClick('delete')}>
          <ListItemText sx={{ color: colors.blush[600] }}>Delete Funnel</ListItemText>
        </MenuItem>
      </MenuList>
    </Popover>
  );
};
